import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';

import ProductOverviewProduct from './ProductOverviewProduct';
import {fadeInOut, LoadingVehicle} from '../../common';

export default function ProductOverviewResults({
	items,
	isLoading,
	loadingItems = 6,
	rowClasses = 'product-overview-results',
	colClasses = 'product-overview-results__item',
}) {
	const loadingElements = Array.from(Array(loadingItems).keys());

	return (
		<>
			<div className={rowClasses}>
				{!isLoading &&
					items.map((item, itemIndex) => {
						return (
							<div key={itemIndex} className={colClasses}>
								<ProductOverviewProduct
									vehicle={item}
								/>
							</div>
						);
					})}
				<AnimatePresence>
					{isLoading &&
						loadingElements.map((_item, elementIndex) => (
							<div key={elementIndex} className={colClasses}>
								<motion.div {...fadeInOut()}>
									<LoadingVehicle />
								</motion.div>
							</div>
						))}
				</AnimatePresence>
			</div>
		</>
	);
}
